import { useMutation } from '@src/query';


/**
 * Settings → Billing mutation hooks (T10). Each wraps the shared `useMutation`
 * engine with the injected-`queryClient` `mutateFn({ apiClient, queryClient })`
 * contract — the corelib query singleton is NOT imported here. Invalidation runs
 * inside `mutateFn`; the caller passes both the billing `queryKey` and the org
 * `mineKey` it already holds (a plan change invalidates the org too), so the
 * exact cache keys are preserved unchanged.
 *
 * Mirrors `query/garage/useDonorMutations.js`.
 */

function refresh(queryClient, queryKey, mineKey) {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey }),
    queryClient.invalidateQueries({ queryKey: mineKey }),
  ]);
}


/** Switch subscription plan (demo billing — activates instantly). Variables:
 * `{ sellerId, plan, queryKey, mineKey }`. */
function useBillingPlanMutation(params) {
  return useMutation({
    mutateFn: ({ apiClient, queryClient, sellerId, plan, queryKey, mineKey }) => apiClient
      .request({ url: `/sellers/${sellerId}/billing/plan/`, method: 'POST', payload: { plan } })
      .then((data) => refresh(queryClient, queryKey, mineKey).then(() => data)),
    ...params,
  });
}


/** Toggle the interchange (fitment) add-on. Variables: `{ sellerId, enabled,
 * queryKey, mineKey }`. */
function useBillingInterchangeMutation(params) {
  return useMutation({
    mutateFn: ({ apiClient, queryClient, sellerId, enabled, queryKey, mineKey }) => apiClient
      .request({ url: `/sellers/${sellerId}/billing/interchange/`, method: 'POST', payload: { enabled } })
      .then((data) => refresh(queryClient, queryKey, mineKey).then(() => data)),
    ...params,
  });
}


export {
  useBillingInterchangeMutation,
  useBillingPlanMutation,
};
